import { useElementResponsive } from '@bydesign-ui/hooks';
import { classnames } from '@bydesign-ui/utils';
import React, { useMemo, useRef } from 'react';
import { usePrefixCls } from '@byte-design/config';
import { Aside } from './Aside';
import { Content } from './Content';
import { LayoutInfoContext } from './context/LayoutInfoContext';
import { Footer } from './Footer';
import { Header } from './Header';
import { formatBreakpoints } from './util/breakpoint';
export function Layout(props) {
  var className = props.className,
      _props$hasAside = props.hasAside,
      hasAside = _props$hasAside === void 0 ? false : _props$hasAside,
      onBreakpoint = props.onBreakpoint,
      _props$breakpoints = props.breakpoints,
      breakpoints = _props$breakpoints === void 0 ? [] : _props$breakpoints,
      children = props.children;
  var theme = 'light';
  var container = useRef(null);
  var layoutInfo = {
    theme: theme,
    hasAside: hasAside
  };
  var fk = useMemo(function () {
    return formatBreakpoints(breakpoints);
  }, [breakpoints]);
  useElementResponsive(container, function () {
    return !!onBreakpoint;
  }, fk, onBreakpoint);
  var cls = classnames(usePrefixCls('layout', {
    'has-aside': hasAside
  }), usePrefixCls("layout-".concat(theme)), className);
  return React.createElement(LayoutInfoContext.Provider, {
    value: layoutInfo
  }, React.createElement("section", {
    className: cls,
    ref: container
  }, children));
}
Layout.Aside = Aside;
Layout.Content = Content;
Layout.Header = Header;
Layout.Footer = Footer;